import { BorderRadius, Color, getShadow, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReportContentWrapper = styled.table`
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R12};
  border-collapse: separate;
  border-spacing: 0;
  background-color: ${Color.White};
  overflow: hidden;
  ${getShadow('raisedLight')};
`

export const PreviewSkeletonWrapper = styled.div`
  padding: ${Spacing.S16};
`
